import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { putNotifyNotificationContentArchived } from "../../../queries/notify";
import { buildNotifyInfiniteNotificationContentQueryKey } from "./useInfiniteNotificationContent";
import { buildNotifyContentDetailsQueryKey } from "./useNotifyContent";

interface IUseNotifyNotificationContentAction {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useNotifyNotificationContentArchive({ onSuccess, onError }: IUseNotifyNotificationContentAction = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [archiveNotificationContentMutation, { isLoading: isArchiveNotificationContentLoading }] = useMutation(
    putNotifyNotificationContentArchived(networkHeaders),
    {
      onSuccess: async (_, id) => {
        // Add relevant query invalidations here based on your data structure
        await queryCache.invalidateQueries(
          buildNotifyContentDetailsQueryKey({
            id,
          }),
        );
        setTimeout(async () => {
          await queryCache.invalidateQueries(buildNotifyInfiniteNotificationContentQueryKey());
        }, 1000);
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: onError,
    },
  );

  const archiveNotificationContent = async (id: number) => {
    return await archiveNotificationContentMutation(id);
  };

  return { archiveNotificationContent, isArchiveNotificationContentLoading };
}
